import React, { useEffect, useState } from "react";
import styles from "./CardDetailImage.module.css";
import Grid from "@material-ui/core/Grid";
import toArrayImageFromImageRegex from "shared/func/toArrayImageFromImageRegex";

const CardDetailImage = (props) => {
  const { imgPathRegex } = props;
  const images = toArrayImageFromImageRegex(imgPathRegex);
  const [imgMain, setImgMain] = useState(images[0]);

  useEffect(() => {
    setImgMain(images[0]);
  }, [props]);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <img
            src={imgMain}
            style={{ borderRadius: "6px" }}
            alt="not found..."
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        {images.map((item, index) => {
          if (item) {
            return (
              <Grid
                item
                xs={3}
                sm={3}
                key={index}
                onClick={() => setImgMain(item)}
                className={styles.img_item}
              >
                <img
                  src={item}
                  style={{ borderRadius: "6px" }}
                  alt="not found..."
                />
              </Grid>
            );
          }
        })}
      </Grid>
    </div>
  );
};

export default CardDetailImage;
